<script>
import Service from '../../services/movement-instruction';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import Fieldset from 'primevue/fieldset';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Toolbar from 'primevue/toolbar';
import Editor from 'primevue/editor';
import Textarea from 'primevue/textarea';
import Dialog from 'primevue/dialog';

import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
// import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue'
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericBooleanDropdown from '../generic/GenericBooleanDropdown.vue'
import LabelField from '../../components/generic/LabelField.vue'
import VesselSearchDialog from '../../components/vessel/VesselSearchDialog.vue'
import VesselFinderDialog from '../../components/vessel/VesselFinderDialog.vue';
import MovementInstructionEta from '../../components/movement-instruction/MovementInstructionEta.vue';
import MovementInstructionCloneNote from './MovementInstructionCloneNote.vue';
import VesselNominationDialogApplyAll from '@/components/movement-instruction/VesselNominationDialogApplyAll.vue';

import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

const checkLaycanDates = helpers.withMessage('movementInstructions.messages.laycanDateValidation', function(el){
 
  if(this.data.laycanStartDate && this.data.laycanEndDate){
    if(this.data.laycanStartDate > this.data.laycanEndDate){
      return false;
    }
  }
  return true;
});


export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
      Toolbar, 
      Editor, Textarea, Fieldset, InputText, InputNumber,  
      GenericCustomMasterDataAutocompleteV2, GenericBooleanDropdown, GenericCustomAutocompleteV2, //GenericDateTimeMaskV2,
      LabelField,  
      VesselSearchDialog, VesselFinderDialog, MovementInstructionEta, Dialog, MovementInstructionCloneNote,
      ResponsiveButton, VesselNominationDialogApplyAll
  },
  props: ['id', 'readOnly', 'visibilityData', 'onPlantChange', 'lots', 'proposal'],
  data(){
    return {
      data: {
        idOperationType: null,
        loadingLaytime: 0,
        loadingFreetime: 0,
        dischargeLaytime: 0,
        dischargeFreetime: 0
      },
      submitted: false,
      searchVesselDialogVisible: {
        visible: false
      },
      vesselFinderDialogData: {
        visible: false
      },
      etaDialogData: {
        visible: false
      },
      isOnlyOneLotPermitted: false,
      isAlreadySavedAsFavourite: undefined,
      favouriteId: null,
      saveAsFavouriteVisible: false,
      saveAsFavouriteDepartmentNote: '',
      proposalText: "",
      proposalDate: null,
      proposalField: null,
      vesselNominationApproveDialogVisible: false,
      proposalApplyAllRecords: {},
      proposalDemurrageRateValue: null,
      proposalDemurrageRateCurrency: null,
      proposalDemurrageRateUom: null
    }
  },
  validations(){
    return {
      data: {
        voyageNumber: {  },
        idRegistryVessel: { },
        vessel: {  },
        idOperationType: { required },
        idRegistryInspector: {  },
        idRegistryShippingAgency: {  },
        idPlant: { required },
        laycanStartDate: { required, checkLaycanDates },
        laycanEndDate: { required, checkLaycanDates },
        etaDate: {  },
        loadingLaytime: {  },
        loadingFreetime: {  },
        dischargeLaytime: {  },
        dischargeFreetime: {  },
        laytimeUoMCode: {},
        demurrageRate: {},
        currencyCode: {},
        isCrudeOilWashing: {},
        crudeOilWashingHours: {},
        pipeTransferTypeFlag: {}
      }
    }
  },
  mounted(){
    this.loadHeader();
  },
  computed: {
      constants(){
          return CommonConstants;
      },
      utils(){
        return Utils;
      },
      uiPermissions(){
        return this.$store.getters['security/uiPermissions'];
      }
  },
  methods: {
    save(valid){
      this.submitted = true;

      if (!valid){
          return;
      }

      this.submitted = false;
      
      if(this.id != 0){
        
        this.$store.dispatch("generic/setLoading", true);
        Service.saveHeader(this.data, 
          response => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
              this.loadHeader();
              this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});

              this.$emit('checkMovementInstructionToBeAssociated');
            }else{
              this.$toast.add({detail: response.message && response.message != '' ? this.$t(response.message) :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          }
        );
      }else{
        this.$store.dispatch("generic/setLoading", true);
        Service.createHeader(this.data, 
          response => {
            if(response.success){
              this.$store.dispatch("generic/setLoading", false);
              this.$router.push(
                { 
                    name: 'movement-instruction-details',
                    params: {
                        id: response.data.id
                    },
                    query: { startInEdit: true }
                }
              );
              this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
            }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          }
        );
      }
    },
    loadHeader(){
      if(this.id != 0){
        Service.getHeader(this.id, response => {
          if(response.success){
            if(response.data.laycanStartDate){
                response.data.laycanStartDate = Utils.dateToCurrentTimeZone(response.data.laycanStartDate);
            }
            if(response.data.laycanEndDate){
              response.data.laycanEndDate = Utils.dateToCurrentTimeZone(response.data.laycanEndDate);
            }
            if(response.data.etaDate){
              response.data.etaDate = Utils.dateToCurrentTimeZone(response.data.etaDate);
            }
            for(var key in response.data){
              this.data[key] = response.data[key];
            }
            Service.isMovementInstructionSavedAsFavourite(this.id, response => {
              this.isAlreadySavedAsFavourite = response.success;
              this.favouriteId = response?.data?.id || null;
            });
          }
        });
      }
    },
    openVesselSearch(){
      this.$refs.vesselSearchDialog.show();
    },
    openEta(){
      this.$refs.movementInstructionEta.loadData();
      this.$refs.movementInstructionEta.show();
    },
    changeOperationType(el){
      this.$emit('updateVisibilityData', 'movementDirection', el.extraData.movementDirection);
      this.$emit('updateVisibilityData', 'transportType', el.extraData.transportType);
      this.$emit('updateHeaderData', 'idOperationType', el.value);
      this.$emit('updateHeaderData', 'showIsFip', el.extraData.isFip);
      this.data.pipeTransferTypeFlag = this.visibilityData.transportType == CommonConstants.transportType.PIPE ? 'P' : null;    
      this.isOnlyOneLotPermitted = el.extraData.isOnlyOneLotPermitted;
    },
    showVessel(){
      this.vesselFinderDialogData.vesselId = this.data.idRegistryVessel;
      this.$refs.vesselFinderDialog.loadVessel();
    },
    onIsCruidOilWashingChange(){
      if(!this.data.isCrudeOilWashing){
        this.data.crudeOilWashingHours = 0;
      }
    },
    updateVessel(vessel){
      this.data.idRegistryVessel = vessel.id;
      this.data.vessel = vessel.imoNumber + ' ' + vessel.name;
    },
    clearVessel(){
      this.data.idRegistryVessel = null;
      this.data.vessel = null;
    },
    openSaveAsFavourite(){

    },
    saveAsFavourite(){
      Service.saveAsFavourite({idMovementInstructionHeader: this.id, departmentNote: this.saveAsFavouriteDepartmentNote}, response => {
        if(response.success){
          this.saveAsFavouriteDepartmentNote = '';
          this.saveAsFavouriteVisible = false;
          Service.isMovementInstructionSavedAsFavourite(this.id, response => {
            this.isAlreadySavedAsFavourite = response.success;
            this.favouriteId = response?.data?.id || null;
          });
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        } else{
          this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      });
    },
    removeFromFavourites(){
      if(this.favouriteId){
        Service.removeFromFavourites(this.favouriteId, response => {
          if(response.success){
              this.isAlreadySavedAsFavourite = false;
              this.favouriteId = null;
              this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          } else{
            this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        });
      }else{
        this.$toast.add({detail: this.$t('messages.generic_error_message'), life:3000, severity:'error'});
      }
    },
    submitCloneNote(note){
      this.data.note = note;
      this.$refs.cloneNoteDialog.hide();
    },
    openCloneNote(){
      this.$refs.cloneNoteDialog.show();
    },
    openProposal(e, field, type){
      this.proposalField = null;
      this.proposalDate = null;
      switch(field){
        case 'inspectors':
        case 'loadingDateRangeFrom':
        case 'loadingDateRangeTo':
        //case 'vesselName':
          this.proposalField = field;

        break;
        case 'demurrageRate': 
            this.proposalField = field;
            this.proposalDemurrageRateValue = this.proposal.demurrageRateValue;
            this.proposalDemurrageRateCurrency =this.proposal.demurrageRateCurrency;
            this.proposalDemurrageRateUom =this.proposal.demurrageRateUom;
        break;
        
      }
      let v = this.proposal[field];
      if(type == 'date'){
        v = Utils.formatDateTime(Utils.dateToCurrentTimeZone(this.proposal[field]));
        this.proposalDate = Utils.dateToCurrentTimeZone(this.proposal[field]);
      }

      let message = v;
      this.proposalText = message;
      this.$refs.proposalop.toggle(e);
    },
    applyProposalText(){
      switch(this.proposalField){
        case 'inspectors':
          this.$refs.inspectorsCombo.queryFilterWithDefault(this.proposalText)
        break;
        case 'loadingDateRangeFrom':
          this.data.laycanStartDate = this.proposalDate
        break;
        case 'loadingDateRangeTo':
          this.data.laycanEndDate = this.proposalDate
        break;
        // case 'vesselName':
        //   this.$refs.vesselSearchDialog.showWithName(this.proposalText);
        //   break;
        case 'demurrageRate':
            this.data.demurrageRate = this.proposalDemurrageRateValue;
            this.data.currencyCode = this.proposalDemurrageRateCurrency;
            this.data.laytimeUoMCode = this.proposalDemurrageRateUom;
        break;
      }
    },
    checkModifiedField(field){
      return this.proposal && this.proposal.modifiedFieldList && this.proposal.modifiedFieldList.length > 0 && this.proposal.modifiedFieldList.includes(field);
    },
    openProposalApplyAllRecords(){
      this.vesselNominationApproveDialogVisible = true;
    },
    applyAllProposal(obj){
      // if(obj.vesselApply){
      //   this.data.idRegistryVessel = obj.idRegistryVessel;
      //   this.data.vessel = obj.vessel;
      // }
      if(obj.inspectorApply){
        this.data.idRegistryInspector = obj.idRegistryInspector;
        this.data.inspector = obj.inspector;
      }
      if(obj.laycanStartDateApply){
        this.data.laycanStartDate = obj.laycanStartDate;
      }
      if(obj.laycanEndDateApply){
        this.data.laycanEndDate = obj.laycanEndDate;
      }
      if(obj.demurrageApply){
        this.data.demurrageRate = obj.demurrageRateValue;
        this.data.currencyCode = obj.demurrageRateCurrency;
        this.data.laytimeUoMCode = obj.demurrageRateUom;
      }
      this.vesselNominationApproveDialogVisible = false;
    }
  },
  watch: {
    'data.idPlant'(newValue){
      this.$emit('updateHeaderData', 'idPlant', newValue);
    },
    'data.laycanStartDate'(newValue){
      this.$emit('updateHeaderData', 'laycanStartDate', newValue);
    },
    'data.idOperationType'(newValue){
      this.$emit('updateHeaderData', 'idOperationType', newValue);
    },
    'data.code'(newValue){
      this.$emit('updateHeaderData', 'code', newValue);
    },
    'data.voyageNumber'(newValue){
      this.$emit('updateHeaderData', 'voyageNumber', newValue);
    },
  }
}

</script>

<template>
  <main>
    <OverlayPanel ref="proposalop">
      <p>Il campo suggerito dall'ultima comunicazione via e-mail è: {{ proposalText }}</p>
        <Toolbar v-if="!readOnly && proposalField">
          <template #end>
            <ResponsiveButton :label="$t('btn.apply')" class="p-button-outlined p-button-sm m-1" @click="applyProposalText"  />
          </template>
        </Toolbar>
    </OverlayPanel>
    <MovementInstructionCloneNote ref="cloneNoteDialog" :submitFn="submitCloneNote"/>
    <Dialog v-model:visible="saveAsFavouriteVisible" :modal="true" :closable="true" :style="{width: '40vw'}">
      <div class="field">
        <label for="saveAsFavouriteDepartmentNote">{{$t('note')}}</label>
        <Textarea v-model="saveAsFavouriteDepartmentNote" class="w-full p-inputtext-sm mt-1 " rows="5" />
      </div>
      <template #footer>
          <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="p-button-outlined p-button-sm m-1" @click="saveAsFavourite" />
        </template>
    </Dialog>
    <VesselSearchDialog ref="vesselSearchDialog" :item="searchVesselDialogVisible" :record="data" @updateVessel="updateVessel" />
    <VesselFinderDialog ref="vesselFinderDialog" :item="vesselFinderDialogData" />
    <MovementInstructionEta ref="movementInstructionEta" :item="etaDialogData" :idMovementInstructionHeader="id"/>
    <Toolbar style="padding: 0;">
      <template #start>
          <ResponsiveButton :label="$t('btn.showVessel')" icon="pi pi-info" class="p-button-outlined p-button-sm m-1" @click="showVessel" v-if="visibilityData.transportType == constants.transportType.SHIP || visibilityData.transportType == constants.transportType.BARGE" />
          <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="p-button-outlined p-button-sm m-1" @click="save(!v$.$invalid)" v-if="!readOnly" :disabled="!uiPermissions('movementInstructionEditButton').isEnabled || readOnly"/>
          <ResponsiveButton :label="$t('btn.saveAsFavourite')" icon="pi pi-star" class="p-button-outlined p-button-sm m-1" :disabled="!uiPermissions('movementInstructionFavouriteButton').isEnabled" @click="saveAsFavouriteVisible = true" v-if="isOnlyOneLotPermitted && !isAlreadySavedAsFavourite && (typeof isAlreadySavedAsFavourite !== 'undefined')" />
          <ResponsiveButton :label="$t('btn.removeFromFavourites')" icon="pi pi-star" class="p-button-outlined p-button-sm p-button-danger m-1" @click="removeFromFavourites" v-if="isAlreadySavedAsFavourite" :disabled="!uiPermissions('movementInstructionFavouriteButton').isEnabled" />
      </template>
    </Toolbar>
    <Dialog v-model:visible="vesselNominationApproveDialogVisible" :modal="true" :closable="true" :style="{width: '40vw'}">
        <VesselNominationDialogApplyAll :proposal="proposal" :actual="data" @applyProposal="applyAllProposal" />
    </Dialog>
    <div class="grid">
      <div class="col-12">
        <div class="card">
          <div class="grid formgrid">
          <ResponsiveButton :label="$t('VesselNomination.page_title')" icon="fa-solid fa-robot" class="p-button-outlined p-button-sm" @click="openProposalApplyAllRecords" v-if="!readOnly && proposal" :disabled="!uiPermissions('movementInstructionEditButton').isEnabled" />
          <Fieldset :legend="$t('general')" class="col-12 mt-2">
            <div class="grid formgrid" >
              <div class="col-12 lg:col-3 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="voyageNumber" :class="{'p-error':v$.data.voyageNumber.$invalid && submitted}">{{$t('movementInstructions.voyageNumber')}}</label>
                  <InputText 
                    :disabled="true"
                    id="voyageNumber" type="text" 
                    v-model="data.voyageNumber" 
                    :class="{'p-invalid':v$.data.voyageNumber.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <div v-if="(v$.data.voyageNumber.$invalid && submitted) || v$.data.voyageNumber.$pending.$response">
                    <small class="p-error" v-for="error in v$.data.voyageNumber.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                  </div>
                <!-- </span>
                <span v-else>
                  <LabelField :value="data.voyageNumber" :label="$t('movementInstructions.voyageNumber')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-3 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="code">{{$t('code')}}</label>
                  <InputText 
                    :disabled="true"
                    id="code" type="text" 
                    v-model="data.code" 
                    :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span> -->
                <!-- <span v-else> -->
                  <!-- <LabelField :value="data.code" :label="$t('code')"/> -->
                <!-- </span> -->
              </div>
              <div class="col-12 lg:col-3 field">
                  <label for="operationType" :class="{'p-error':v$.data.idOperationType.$invalid && submitted}">{{$t('operationType.fk')}}</label>

                <span v-show="!readOnly">
                    <generic-custom-master-data-autocomplete-v-2
                    v-model="data.idOperationType" 
                    :changeFn="changeOperationType"
                    :disabled="data.id"
                    name="user-role-operation-type-combo"
                    api="movement-instruction/user-role-operation-type-combo"
                    :class="{'p-invalid':v$.data.idOperationType.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <div v-if="(v$.data.idOperationType.$invalid && submitted) || v$.data.idOperationType.$pending.$response">
                    <small class="p-error" v-for="error in v$.data.idOperationType.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                  </div>
                </span>
                <span v-show="readOnly">
                  <InputText class="w-full p-inputtext-sm mt-1" v-model="data.operationType" disabled />
                  <!-- <LabelField :value="data.operationType" :label="$t('operationType.fk')"/> -->
                </span>
              </div>
 
              <div class="col-12 lg:col-3 field"  v-if="visibilityData.transportType == constants.transportType.PIPE">
                <!-- <span v-if="!readOnly"> -->
                  <label for="pipeTransferTypeFlag" :class="{'p-error':v$.data.pipeTransferTypeFlag.$invalid && submitted}">{{$t('movementInstructions.pipeTransferTypeFlag')}}</label>
                    <GenericCustomAutocompleteV2
                    field="label"
                    :disabled="readOnly"
                    v-model="data.pipeTransferTypeFlag" 
                    :staticOptions="constants.pipeTransferFlags"
                    :format="{ label: function(e){
                        return $t('movementInstructions.' + e.label)
                    }, value: 'id' }"
                    :class="{'p-invalid':v$.data.pipeTransferTypeFlag.$invalid && submitted, 'p-inputtext-sm w-full': true}" />
                  <div v-if="(v$.data.pipeTransferTypeFlag.$invalid && submitted) || v$.data.pipeTransferTypeFlag.$pending.$response">
                    <small class="p-error" v-for="error in v$.data.pipeTransferTypeFlag.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                  </div>
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.pipeTransferTypeFlag ? $t(constants.getPipeTransferLabel(data.pipeTransferTypeFlag)) : ''" :label="$t('movementInstructions.pipeTransferTypeFlag')"/>
                </span> -->
              </div>             
              <div class="col-12 lg:col-3 field" v-if="visibilityData.transportType == constants.transportType.SHIP">
                  <label for="vessel" :class="{'p-error':v$.data.vessel.$invalid && submitted}">{{$t('vessel.fk')}}</label>
                  <div class="p-inputgroup">
                    <ResponsiveButton icon="pi pi-trash" @click="clearVessel" class=" mt-1 "
                      :disabled="readOnly"/>
                    <InputText 
                    :disabled="true"
                    id="vessel" type="text" 
                    v-model="data.vessel" 
                    :class="{'p-invalid':v$.data.vessel.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <ResponsiveButton icon="pi pi-search" @click="openVesselSearch" class=" mt-1 " :disabled="readOnly"/>
                    <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'vesselName')" class="mt-1" :class="{'p-button-danger': checkModifiedField('vesselName'), 'p-button-success': !checkModifiedField('vesselName')}" v-if="proposal && proposal.vesselName" />
                  </div>
              </div>
              <div class="col-12 lg:col-3 field" v-if="visibilityData.transportType == constants.transportType.SHIP && visibilityData.movementDirection == 'IN'">
                  <!-- <span v-if="!readOnly"> -->
                    <div>
                      <label for="shipToShip">{{$t('movementInstructions.shipToShip')}}</label>
                    </div>
                    <GenericBooleanDropdown
                      id="shipToShip" 
                      :disabled="readOnly"
                      v-model="data.isShipToShip" 
                       :class="{'w-full p-inputtext-sm mt-3 ': true}" />
                  <!-- </span> -->
                  <!-- <span v-else>
                    <LabelField :value="data.isFip ? $t('yes') : $t('no')" :label="$t('movementInstructions.isFip')"/>
                  </span> -->
                </div>
              <div class="col-12 lg:col-3 field">
                  <label for="inspector" :class="{'p-error':v$.data.idRegistryInspector.$invalid && submitted}">{{$t('inspector.fk')}}</label>
                  <div class="p-inputgroup">
                    <GenericCustomMasterDataAutocompleteV2
                    ref="inspectorsCombo"
                  v-model="data.idRegistryInspector" 
                    :disabled="readOnly"
                    name="inspectors" 
                    api="masterdata/inspector-combo"
                    :class="{'p-invalid':v$.data.idRegistryInspector.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'inspectors')" class="mt-1" :class="{'p-button-danger': checkModifiedField('inspectors'), 'p-button-success': !checkModifiedField('inspectors')}" v-if="proposal && proposal.inspectors" />
                </div>
              </div>
              <div class="col-12 lg:col-3 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="plant" :class="{'p-error':v$.data.idPlant.$invalid && submitted}">{{$t('registryPlant.fk')}}</label>
                  <generic-custom-master-data-autocomplete-v-2
                    ref="plantAutocomplete"
                    v-model="data.idPlant"
                    :changeFn="onPlantChange"
                    :disabled="readOnly"
                    name="plants" 
                    api="masterdata/registry-plant-combo"
                    :format="{ label: 'code', value: 'id' }" sortField="Code"
                    :class="{'p-invalid':v$.data.idPlant.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <div v-if="(v$.data.idPlant.$invalid && submitted) || v$.data.idPlant.$pending.$response">
                    <small class="p-error" v-for="error in v$.data.idPlant.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                  </div>
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.plant" :label="$t('registryPlant.fk')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-3 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="voyageNumber" :class="{}">{{$t('movementInstructions.externalVoyageNumber')}}</label>
                  <InputText 
                    :disabled="readOnly"
                    id="externalVoyageNumber" type="text" 
                    v-model="data.externalVoyageNumber" 
                    :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.externalVoyageNumber" :label="$t('movementInstructions.externalVoyageNumber')"/>
                </span> -->
              </div>
            </div>
          </Fieldset>
          
          <Fieldset :legend="$t('movementInstructions.laycanData')" class="col-12 mt-2">
            <div class="grid formgrid" >
              <div class="col-12 lg:col-3 field">
                  <label for="laycanFrom" :class="{'p-error':v$.data.laycanStartDate.$invalid && submitted}">{{$t('movementInstructions.laycanFrom')}}</label>
                  <div class="p-inputgroup">
                    <Calendar 
                      :placeholder="constants.DATE_PLACEHOLDER_POINT"
                      :dateFormat="constants.DATE_FORMAT_POINT"
                      :showTime="true" :hideOnDateTimeSelect="true"
                      :disabled="readOnly"
                      id="laycanFrom" 
                      v-model="data.laycanStartDate"
                      :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                      :class="{'p-invalid':v$.data.laycanStartDate.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'loadingDateRangeFrom', 'date')" class="mt-1" :class="{'p-button-danger': checkModifiedField('loadingDateRangeFrom'), 'p-button-success': !checkModifiedField('loadingDateRangeFrom')}" v-if="proposal && proposal.loadingDateRangeFrom" />
                </div>
                <div v-if="(v$.data.laycanStartDate.$invalid && submitted) || v$.data.laycanStartDate.$pending.$response">
                    <small class="p-error" v-for="error in v$.data.laycanStartDate.$silentErrors" :key="error.$validator">
                        {{$t(error.$message)}}
                    </small>
                  </div>
              </div>
              <div class="col-12 lg:col-3 field">
                  <label for="laycanTo" :class="{'p-error':v$.data.laycanEndDate.$invalid && submitted}">{{$t('movementInstructions.laycanTo')}}</label>
                  <div class="p-inputgroup">
                  <Calendar 
                    :placeholder="constants.DATE_PLACEHOLDER_POINT"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="true" :hideOnDateTimeSelect="true"
                    :disabled="readOnly"
                    id="laycanTo" 
                    v-model="data.laycanEndDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                    :class="{'p-invalid':v$.data.laycanEndDate.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'loadingDateRangeTo', 'date')" class="mt-1" :class="{'p-button-danger': checkModifiedField('loadingDateRangeTo'), 'p-button-success': !checkModifiedField('loadingDateRangeTo')}" v-if="proposal && proposal.loadingDateRangeTo" />
                  </div>
                  <div v-if="(v$.data.laycanEndDate.$invalid && submitted) || v$.data.laycanEndDate.$pending.$response">
                    <small class="p-error" v-for="error in v$.data.laycanEndDate.$silentErrors" :key="error.$validator">
                        {{$t(error.$message)}}
                    </small>
                  </div>
              </div>
              <div class="col-12 lg:col-3 field" v-if="visibilityData.transportType == constants.transportType.SHIP">
                <!-- <span v-if="!readOnly"> -->
                  <label for="etaDate" :class="{'p-error':v$.data.etaDate.$invalid && submitted}">{{$t('movementInstructions.etaDate')}}</label>
                  <Calendar 
                    :placeholder="constants.DATE_PLACEHOLDER_POINT"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="true" :hideOnDateTimeSelect="true"
                    :disabled="readOnly"
                    id="etaDate" 
                    v-model="data.etaDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                    :class="{'p-invalid':v$.data.etaDate.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- <generic-date-time-mask-v-2 
                    :readonly="readOnly"
                    id="etaDate" 
                    :showTime="true" :showSeconds="true"
                    v-model="data.etaDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :inputClass="{'p-invalid':v$.data.etaDate.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> -->
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="utils.formatDateTime(data.etaDate)" :label="$t('movementInstructions.etaDate')"/>
                </span> -->
              </div>
              <!-- <div class="col-12 lg:col-3 field" v-if="visibilityData.transportType == constants.transportType.SHIP"> -->
              <div class="col-12 lg:col-3 field" v-if="false">
                <ResponsiveButton :label="$t('movementInstructions.eta')" icon="pi pi-calendar" class="m-4" @click="openEta" v-if="!readOnly" :disabled="readOnly"/>
              </div>
            </div>
          </Fieldset>

          
          <Fieldset :legend="$t('movementInstructions.laytimeData')" v-if="visibilityData.transportType == constants.transportType.SHIP" class="col-12 lg:col-4 mt-2">
            <div class="grid formgrid" >
              <div class="col-12 lg:col-6 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="loadingLaytime" :class="{'p-error':v$.data.loadingLaytime.$invalid && submitted}">{{$t('movementInstructions.loadingLaytime')}}</label>
                  <InputNumber 
                  :disabled="readOnly"
                      id="loadingLaytime" 
                      v-model="data.loadingLaytime"
                      :class="{'p-invalid':v$.data.loadingLaytime.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> 
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.loadingLaytime" :label="$t('movementInstructions.loadingLaytime')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-6 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="loadingFreetime" :class="{'p-error':v$.data.loadingFreetime.$invalid && submitted}">{{$t('movementInstructions.loadingFreetime')}}</label>
                  <InputNumber 
                  :disabled="readOnly"
                      id="loadingFreetime" 
                      v-model="data.loadingFreetime"
                      :class="{'p-invalid':v$.data.loadingFreetime.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> 
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.loadingFreetime" :label="$t('movementInstructions.loadingFreetime')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-6 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="dischargeLaytime" :class="{'p-error':v$.data.loadingLaytime.$invalid && submitted}">{{$t('movementInstructions.dischargeLaytime')}}</label>
                  <InputNumber 
                  :disabled="readOnly"
                      id="dischargeLaytime" 
                      v-model="data.dischargeLaytime"
                      :class="{'p-invalid':v$.data.dischargeLaytime.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> 
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.dischargeLaytime" :label="$t('movementInstructions.dischargeLaytime')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-6 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="dischargeFreetime" :class="{'p-error':v$.data.dischargeFreetime.$invalid && submitted}">{{$t('movementInstructions.dischargeFreetime')}}</label>
                  <InputNumber 
                  :disabled="readOnly"
                      id="dischargeFreetime" 
                      v-model="data.dischargeFreetime"
                      :class="{'p-invalid':v$.data.dischargeFreetime.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> 
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.dischargeFreetime" :label="$t('movementInstructions.dischargeFreetime')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-6 field">
                  <LabelField :value="isNaN(data.loadingLaytime + data.dischargeLaytime) ? 0 : data.loadingLaytime + data.dischargeLaytime" :label="$t('movementInstructions.totalLaytime')"/>
              </div>
              <div class="col-12 lg:col-6 field">
                  <LabelField :value="isNaN(data.loadingFreetime + data.dischargeFreetime) ? 0 : data.loadingFreetime + data.dischargeFreetime" :label="$t('movementInstructions.totalFreetime')"/>
              </div>
            </div>
          </Fieldset>
          <Fieldset :legend="$t('movementInstructions.isCrudeOilWashing')" v-if="visibilityData.transportType == constants.transportType.SHIP" class="col-12 lg:col-2 mt-2">
            <div class="grid formgrid" >
              <div class="col-12 lg:col-12 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="isCrudeOilWashing">{{$t('movementInstructions.isCrudeOilWashing')}}</label>
                  <GenericBooleanDropdown
                    @change="onIsCruidOilWashingChange"
                    id="isCrudeOilWashing" 
                    v-model="data.isCrudeOilWashing" 
                    :disabled="readOnly"
                    class="w-full p-inputtext-sm mt-1 "
                  />
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.isCrudeOilWashing ? $t('yes') : $t('no')" :label="$t('movementInstructions.crudeOilWashingHours')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-12 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="crudeOilWashingHours" :class="{'p-error':v$.data.crudeOilWashingHours.$invalid && submitted}">{{$t('movementInstructions.crudeOilWashingHours')}}</label>
                  <InputNumber 
                      :disabled="!data.isCrudeOilWashing || readOnly"
                      id="crudeOilWashingHours" 
                      v-model="data.crudeOilWashingHours"
                      :class="{'p-invalid':v$.data.crudeOilWashingHours.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> 
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.crudeOilWashingHours" :label="$t('movementInstructions.crudeOilWashingHours')"/>
                </span> -->
              </div>
            </div>
          </Fieldset>
          <Fieldset :legend="$t('movementInstructions.demurrage')" v-if="visibilityData.transportType == constants.transportType.SHIP" class="col-12 lg:col-5 mt-2">
            <div class="grid formgrid" >
              <div class="col-12 lg:col-6 field">
                <label for="demurrageRate" :class="{'p-error':v$.data.demurrageRate.$invalid && submitted}">{{$t('movementInstructions.demurrageRate')}}</label>
                <div class="p-inputgroup">
                  <InputNumber 
                  :disabled="readOnly"
                      id="demurrageRate" 
                      v-model="data.demurrageRate"
                      :class="{'p-invalid':v$.data.demurrageRate.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                      <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'demurrageRate')" class="mt-1" :class="{'p-button-danger': checkModifiedField('demurrageRate'), 'p-button-success': !checkModifiedField('demurrageRate')}" v-if="proposal && proposal.demurrageRate" />
                </div>
              </div>
              <div class="col-12 lg:col-6 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="currencyCode" :class="{'p-error':v$.data.currencyCode.$invalid && submitted}">{{$t('currencyCode')}}</label>
                  <generic-custom-master-data-autocomplete-v-2
                    :disabled="readOnly"
                    name="currencies"
                    v-model="data.currencyCode" 
                    api="masterdata/currency-combo"
                    :format="{ label: 'name', value: 'isoCode' }" sortField="Name"
                    :class="{'p-invalid':v$.data.currencyCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.currencyCode" :label="$t('currencyCode')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-6 field">
                <!-- <span v-if="!readOnly"> -->
                  <label for="laytimeUoMCode" :class="{'p-error':v$.data.laytimeUoMCode.$invalid && submitted}">{{$t('laytimeUoM.fk')}}</label>
                  <generic-custom-master-data-autocomplete-v-2
                    :disabled="readOnly"
                    name="laytime-uoms" 
                    v-model="data.laytimeUoMCode" 
                    api="masterdata/unit-of-measure-combo?scope=MovementInstructionLaytime"
                    :class="{'p-invalid':v$.data.laytimeUoMCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span> -->
                <!-- <span v-else>
                  <LabelField :value="data.laytimeUoMCode" :label="$t('laytimeUoM.fk')"/>
                </span> -->
              </div>
            </div>
          </Fieldset>

          <Fieldset :legend="$t('note')" class="col-12 mt-2">
            <div class="grid formgrid" >
              <div class="col-12 lg:col-12 field">
                <span v-if="!readOnly">
                  <label for="versionNote" :class="{}">{{$t('movementInstructions.versionNote')}}</label>
                  <Textarea :disabled="readOnly" id="versionNote" v-model="data.versionNote" class="w-full p-inputtext-sm mt-1 "/>
                </span>
                <span v-else>
                  <LabelField :value="data.versionNote" :label="$t('movementInstructions.versionNote')"/>
                </span>
              </div>
              
              <div class="col-12 lg:col-12 field">
                <span v-if="!readOnly">

                  <label for="note" :class="{}">{{$t('note')}}</label>
                  <ResponsiveButton :label="$t('btn.import')" icon="pi pi-download" class="ml-3 p-button-outlined p-button-sm" @click="openCloneNote" v-if="!readOnly" :disabled="readOnly"/>

                  <Editor :disabled="readOnly" id="note" v-model="data.note" editorStyle="height: 320px" class="my-2">
                    <template v-slot:toolbar>
                      <span class="ql-formats">
                          <select class="ql-size"></select>
                          <select class="ql-font"></select>
                      </span>
                      <span class="ql-formats">
                          <button class="ql-bold"></button>
                          <button class="ql-italic"></button>
                          <button class="ql-underline"></button>
                          <button class="ql-strike"></button>
                      </span>
                      <span class="ql-formats"> 
                        <button class="ql-list" value="ordered"></button> 
                        <button class="ql-list" value="bullet"></button> 
                      </span>
                      <span class="ql-formats"> 
                          <select class="ql-color"></select>
                          <select class="ql-background"></select>
                      </span>
                      <span class="ql-formats"> 
                        <select class="ql-align"> 
                            <option selected></option> 
                            <option value="center"></option> 
                            <option value="right"></option> 
                            <option value="justify"></option> 
                        </select> 
                      </span>
                  </template>
                  </Editor>
                </span>
                <span v-else>
                  <LabelField value=" " :label="$t('note')"/><div v-html="data.note" />
                </span>
              </div>
            </div>
          </Fieldset>
          
          </div>
        </div>
      </div>
    </div>
    <Toolbar style="padding: 0;" v-if="!readOnly">
      <template #end>
          <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="p-button-outlined p-button-sm" @click="save(!v$.$invalid)" v-if="!readOnly" :disabled="!uiPermissions('movementInstructionEditButton').isEnabled || readOnly"/>
      </template>
    </Toolbar>
  </main>
</template>
